import classes from './style/button.module.css'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { HashLink } from 'react-router-hash-link';
const Button = () => {
  return (
    <HashLink className={classes.btn} to="/#work">
        <ul>
		<li><ArrowBackIcon style={{ fontSize: 40 }}/></li>
	    </ul>
    </HashLink>
  )
}

export default Button
